import React from "react";
import styled, { css } from "styled-components";
import { fontSize } from "./common/styled-mixins";

const Heading = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 192px;
  margin-right: 20px;
  padding: 0;
  font-weight: 400;
  font-size: ${fontSize(16)};
  line-height: 39px;
  text-align: left;
  color: #343434;

  ${props => props.theme.direction === "rtl" && css`
    margin-right: 0;
    margin-left: 10px;
    text-align: right;
  `};

  @media(max-width: 959px) {
    margin-right: 0;
    padding-bottom: 5px;
    font-size: ${fontSize(16)};
    line-height: 1;
    font-weight: 400;
    color: #797979;
  }

  ${props =>
    props.subtitle &&
    css`
    line-height: 16px;
  `}
`;

const Subheading = styled.div`
  display: block;
  margin: 5px 0 0 0;
  padding: 0px;
  font-size: ${fontSize(14)};

  @media(max-width: 959px) {
    line-height: 1;
  }
`;

const Warning = styled(Subheading)`
  color: #D05353;
`;

export default function SettingsHeader(props) {
  const { title, subtitle, warning } = props;
  const showColon = props.showColon && props.locale !== "ar";
  return (
    <Heading subtitle={subtitle || warning}>
      {title}{showColon && ":"}
      {subtitle && <Subheading>{subtitle}</Subheading>}
      {warning && <Warning>{warning}</Warning>}
    </Heading>
  );
}



// WEBPACK FOOTER //
// ./src/components/SettingsHeader.js